// Auditoria 07-06 — a Wave-J criou dispatchRunTriage e o marker de resume com
// testes, mas SEM consumidor no caminho vivo (dead-wired): needs_human nunca
// virava ping e o aviso de run órfão nunca aparecia no boot. Este módulo é a
// FIAÇÃO: extraído do SessionWorkspace (module-level, fora do dp-loc) pra ser
// testável de verdade — a lição é que "módulo testado" ≠ "fio ligado".
import { summarizeQualityAudit } from '../../../lib/loop/qualityAuditSummary.js';
import { dispatchRunTriage } from '../../../lib/notifyOutbound.js';
import { takeOrphanRunMark, buildResumeNotice } from '../../../lib/runInFlight.js';
import { isRunning, setRunMessages } from '../../../lib/agentRunStore.js';
import { sessionRoot } from '../../../lib/sessionRoot.js';

/** Sinais do WRAPPER do loop → learning events + ações outbound (W3/Wave-E/Wave-J).
 * @param {any} evt @param {any} session @param {(kind: string, data: any) => void} observe
 * @param {(sessionId: string, files: any[]) => void} noteEdited */
export function handleHarnessSignal(evt, session, observe, noteEdited) {
  const sessionId = session?.id;
  if (evt.type === 'quality_audit') observe('quality_audit', summarizeQualityAudit(evt));
  if (evt.type === 'delivery_score') {
    observe('delivery_score', { score: evt.score, measured: evt.measured });
    noteEdited(sessionId, evt.files);
  }
  if (evt.type === 'repeated_tool_error') observe('repeated_tool_error', { name: evt.name, count: evt.count });
  if (evt.type === 'run_triage') {
    observe('run_triage', { klass: evt.klass, action: evt.action, stopReason: evt.stopReason });
    // needs_human vira ping REAL (nativa + webhook). Best-effort: nunca derruba a UI.
    void dispatchRunTriage({ root: sessionRoot(session), sessionId, triage: evt });
  }
}

/** Boot da sessão: run que morreu no meio (crash/fechou o app) vira aviso de
 * retomada na conversa. Run VIVO no store (v12: sobrevive a unmount/remount)
 * NÃO é órfão — nesse caso nem consome o marker. */
export function surfaceOrphanRunNotice(sessionId) {
  if (!sessionId || isRunning(sessionId)) return;
  const mark = takeOrphanRunMark(sessionId);
  if (!mark) return;
  setRunMessages(sessionId, (msgs) => [...(msgs || []), {
    id: `resume-${sessionId}-${Date.now()}`,
    created_at: new Date().toISOString(),
    role: 'system',
    content: buildResumeNotice(mark),
  }]);
}
